/**
 * Поиск по всех элементов
 * @param selectors
 * @param parent
 * @returns {NodeListOf<HTMLElementTagNameMap[keyof HTMLElementTagNameMap]>|*}
 */
function findAll(selectors, parent = null) {
	if (parent) {
		return parent.querySelectorAll(selectors);
	} else {
		return document.querySelectorAll(selectors);
	}
}

/**
 * Поиск элемента
 * @param selector
 * @param parent
 * @returns {HTMLAnchorElement|HTMLElement|HTMLAreaElement|HTMLAudioElement|HTMLBaseElement|HTMLQuoteElement|HTMLBodyElement|HTMLBRElement|HTMLButtonElement|HTMLCanvasElement|HTMLTableCaptionElement|HTMLTableColElement|HTMLDataElement|HTMLDataListElement|HTMLModElement|HTMLDetailsElement|HTMLDialogElement|HTMLDivElement|HTMLDListElement|HTMLEmbedElement|HTMLFieldSetElement|HTMLFormElement|HTMLHeadingElement|HTMLHeadElement|HTMLHRElement|HTMLHtmlElement|HTMLIFrameElement|HTMLImageElement|HTMLInputElement|HTMLLabelElement|HTMLLegendElement|HTMLLIElement|HTMLLinkElement|HTMLMapElement|HTMLMenuElement|HTMLMetaElement|HTMLMeterElement|HTMLObjectElement|HTMLOListElement|HTMLOptGroupElement|HTMLOptionElement|HTMLOutputElement|HTMLParagraphElement|HTMLPictureElement|HTMLPreElement|HTMLProgressElement|HTMLScriptElement|HTMLSelectElement|HTMLSlotElement|HTMLSourceElement|HTMLSpanElement|HTMLStyleElement|HTMLTableElement|HTMLTableSectionElement|HTMLTableCellElement|HTMLTemplateElement|HTMLTextAreaElement|HTMLTimeElement|HTMLTitleElement|HTMLTableRowElement|HTMLTrackElement|HTMLUListElement|HTMLVideoElement|*}
 */
function find(selector, parent = null) {
	if (parent) {
		return parent.querySelector(selector);
	} else {
		return document.querySelector(selector);
	}
}

/**
 * Поиск по ID
 * @param selector
 * @param parent
 * @returns {HTMLElement|*}
 */
function findID(selector, parent = null) {
	if (parent) {
		return parent.getElementById(selector);
	} else {
		return document.getElementById(selector);
	}
}

export {find, findAll, findID}
